@import "../../../../../shared/scss";

:host {
  .tag {
    &:not(:last-child) {
      padding-inline-end: $pds-spacing-fluid-x-small;
    }
  }
}
